var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rk-box",style:(_vm.width?("width: " + _vm.width + ";"):'')},[_c('div',{staticClass:"rk-box-title ell"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"rk-box-container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }